<template>
    <div ref="content" class="tab-data-grid-content">
        <slot/>
    </div>
</template>

<script>
import bus from './bus'
export default {
    name: 'tab-data-grid-item',
    props: {
        name: {
            type: String
        }
    },
    methods: {
        onCurrentChange () {
            bus.$emit('on-tab-change')
        }
    },
    mounted () {
        this.$nextTick(() => {
            this.$parent.$parent.$parent.tabItems.push(this)
        })
    }
}
</script>

<style lang="less">
.tab-data-grid-content {
    padding-top: 10px;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/tab-data-grid-item.vue